module.exports = __webpack_public_path__ + "img/img_image1.87b26d3c.webp";